module.exports = __webpack_public_path__ + "img/cpzxIcon6.c2435b7e.png";